import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { TextField, Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import { FaInstagram, FaFacebookF, FaYoutube, FaTwitter, FaPinterest, FaSnapchatGhost, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";

import SnapchatIcon from '@mui/icons-material/FilterDrama';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="futuristic-footer">
      <Container>
        <Row className="footer-content">
          {/* Quick Links */}
          <Col md={4} className="footer-section">
            <h6 className="footer-heading">QUICK LINKS</h6>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </Col>

          {/* Customer Support */}
          <Col md={4} className="footer-section">
            <h6 className="footer-heading">CUSTOMER SUPPORT</h6>
            <ul className="footer-links">
              <li><Link to="/contact">Contact us</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
            </ul>
          </Col>

          {/* Our Collection */}
          <Col md={4} className="footer-section">
            <h6 className="footer-heading">OUR COLLECTION</h6>
            <ul className="footer-links">
              <li><Link to="/collections">All Collection</Link></li>
              <li><Link to="/new-arrivals">New Arrivals</Link></li>
              <li><Link to="/diamonds">Diamonds</Link></li>
            </ul>
          </Col>
        </Row>


        {/* Social Media */}
        <Row className="social-media-section">
          <Col>
            <div className="social-icons">
              <a href="https://www.instagram.com/nmdiamondofficial" target="_blank" rel="noopener noreferrer">
                <FaInstagram className="social-icon" />
              </a>
              
              <a href="https://youtube.com/@nmdiamond-z9u?feature=shared" target="_blank" rel="noopener noreferrer">
                <FaYoutube className="social-icon" />
              </a>

              <a href="https://wa.me/919205894678" target="_blank" rel="noopener noreferrer">
                <FaWhatsapp className="social-icon" />
              </a>
            </div>
          </Col>
        </Row>

        {/* Copyright */}
        <Row className="copyright-section">
          <Col>
            <p className="copyright-text">
              © {currentYear} NM Diamond. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;